export const TileSize = 16
export const SpriteSize = 32
export const ChunkSize = 32
